module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			descriptionTitle: true,
			productDescription: true,
			metaTitle: true,
			metaDescription: true,
		},
		buttonContext: 'productAdditionalInformation',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'mblx_productsAdditionalInformation',
		rowActionsProperties: {
			colWidth: '55px'
		},
		customColActionsFile: 'templates/mblx/products/additionalInformation/tableCustomColActions',
		rowActions: {},
		useSelectionObjectFormat: true,
		useSelectionObjectKeyAttribute: 'number'
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'productAdditionalInformationID',
				direction: 'asc'
			}]
		}
	},

	methods: {

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID) {
				const entityAttributes = rowData.attributes || {}
				return this.performAndStoreAction(
					'showEdit_productAdditionalInformation_inEffect',
					this.prepareAction(
						'showEdit_productAdditionalInformation',
						undefined,
						{
							productsAdditionalInformationProperties: { resourceID: rowID },
							productProperties: { resourceID: entityAttributes.productID },
						}
					),
					true
				)
			}
		},

		async requestProductAdditionalInformation(rowID, rowData, buttonMode){
			await getComponent('mblxController').requestProductAdditionalInformation('productAdditionalInformation', rowID, rowData);
		},
	},

	handlers: [{
		name: 'onUploadComplete',
		componentClass: 'templates_mblx_products_additionalInformation_importerUploader',
		handle: function(callerComponent, success){
			if(success){
				this.refreshData(true)
			}
		}
	},{
		name: 'productAdditionalInformationRequested',
		handle: function(callerComponent, success){
			this.refreshData(true)
		}
	},{
		name: 'onSubmitDone',
		componentClass: 'templates_mblx_products_propertiesForm',
		handle: function(callerComponent, nodeData, insertPerformed){
			this.refreshData(true)
		}
	}]
}
